import { useMenuBalanceContext } from 'moduleBase/modules/menu-balance/hooks/use-menu-balance-context';
import { MenuItem } from 'moduleBase/components/menu/MenuItem';
import * as React from 'react';

const MenuItemList = () => {
  const {
    menu,
    hide,
  } = useMenuBalanceContext();

  const list = menu.items.map((menuItem) => (
    <div className="dropdown-flat-list__item" key={menuItem.label}>
      <MenuItem
        {...menuItem}
        onClick={() => {
          hide();
        }}
      />
    </div>
  ));

  return (
    <div className="dropdown-flat-list">
      {list}
    </div>
  );
};

export { MenuItemList };
